define('zero-clipboard-binding',['require','knockout','zero-clipboard'],function (require) {
    var ko = require('knockout');
    var ZeroClipboard = require('zero-clipboard');

    ko.bindingHandlers.zeroClipboard = {
        init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
            ZeroClipboard.config({swfPath: 'https://cdnjs.cloudflare.com/ajax/libs/zeroclipboard/' +
            '2.1.6/ZeroClipboard.swf'});

            var client = new ZeroClipboard(element);
            var isClipBoardEnabled;

            client.on('ready', function () {
                client.on('beforecopy', function () {
                    isClipBoardEnabled = ko.unwrap(valueAccessor());
                });
                client.on('copy', function (event) {
                    if (!isClipBoardEnabled) {
                        event.clipboardData.clearData();
                    }
                });
                client.on('aftercopy', function (event) {
                    if (isClipBoardEnabled) {
                        var $button = $(event.target);
                        var $skipButton = $button.siblings('.skip');
                        var $copySuccess = $button.parent().children('.copy-success');

                        var toggleButtons = function () {
                            $button.toggleClass('visibility', 'hidden');
                            $skipButton.toggleClass('visibility', 'hidden');
                        };

                        toggleButtons();
                        $copySuccess.addClass('show animated flipInX');

                        $button.parent().children('.copy-success')
                            .one('webkitAnimationEnd mozAnimationEnd MSAnimationEnd ' +
                            'oanimationend animationend', function () {
                                setTimeout(function () {
                                    $copySuccess.removeClass('animated flipInX');
                                    $('.show').fadeOut('slow', function () {
                                        $copySuccess.removeClass('show');
                                        toggleButtons();
                                    });
                                }, 1500);
                            });
                    }
                });
            });

            ko.bindingHandlers.click.init(element, valueAccessor, allBindingsAccessor, viewModel, bindingContext);
        }
    };
});

